import { Property, EnumerationItem, EnumerationType } from '@ecp-caf/common-structure';
import { StructureTypeEnum } from '../structure-type-enum';
import { DtoConstant } from '../gsp-dto-constant';
import { IExtendStrucutreType } from './i-extend-strucutre-type';

export class ExtendEnumType extends EnumerationType implements IExtendStrucutreType{

    kind:string;
    id: string;
    code: string;
    name: string;
    description: string;
    properties: Property[];
    enumerationItems: EnumerationItem[];
    structureType: StructureTypeEnum;    
    root: boolean;
    enable:boolean;
    uri:string;

    constructor(){
        super();
        this.kind=DtoConstant.EXTEND_ENUM_TYPE;
        this.properties=new Array<Property>();
        this.enumerationItems=new Array<EnumerationItem>();
        this.enable=false;
        this.structureType=StructureTypeEnum.ENUM;
    }

    getKind(): string {
        return this.kind;
    }
    getKeys(): any[] {
        throw new Error("Method not implemented.");
    }
    getValue(key: any) {
        throw new Error("Method not implemented.");
    }
}